import React, { useState, useEffect } from "react";

import { Row, Col } from "antd";

import PINZA from "../../image/PINZA.png";
import { useDispatch } from "react-redux";
import { updateProductsState } from "../../store/profile";
import { useSelector } from "react-redux";

import { checkCartIfExist } from "../../helper";
import { LoadingOutlined } from "@ant-design/icons";
import NavbarComponent from "../NavbarComponent";
import Footer from "../FooterComponent";

function TwentyNine() {
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.profile);

  const [loading, setloading] = useState(false);
  const [hitUseEffect, sethitUseEffect] = useState(false);

  const handleLoading = () => {
    setloading(false);
  };

  useEffect(() => {
    setloading(true);

    setTimeout(handleLoading, 1000);
  }, [hitUseEffect, products]);
  return (
    <>
      <NavbarComponent />
      <div>
        <div className="border">
          <Row className="rowo" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={PINZA} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">PINZA MB MB-G1200</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">PESO</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">1.65 TON</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga"> PARA EXCAVADORA</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">18-30 TON</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAPACIDADA DE CARGA</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">0.71 M3</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">ROTATION</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten"> 360°</h6>
                  </div>
                </div>
                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("PINZA MB MB-G1200") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "PINZA",
                                  name: "PINZA MB MB-G1200                                  ",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default TwentyNine;
